import React, { ComponentPropsWithoutRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { IconExit } from '@/components/icons';
import { useUserInfoStore } from '@/store';
import { cn } from '@/utils/cn';

import Button from '../../../components/ui/Button';
import { useEmbeddedLogout, useUser } from '../hooks';

export const LogoutButton = ({ className }: ComponentPropsWithoutRef<'button'>) => {
  const { t } = useTranslation();

  const { data: user } = useUser();

  const { mutateAsync: embeddedLogout } = useEmbeddedLogout();

  const navigate = useNavigate();

  const handleLogOut = async () => {
    await embeddedLogout();
    navigate(0);
  };

  return (
    <Button
      onClick={handleLogOut}
      variant="danger"
      className={cn(
        {
          hidden: !user,
        },
        className,
      )}
    >
      <span className="text-transparent">
        <IconExit size="sm" />
      </span>
      <span>{t('logout', { ns: 'header' })}</span>
    </Button>
  );
};
